import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full h-[420px] md:h-[500px] overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20abstract%20digital%20wave%20flow%20with%20soft%20golden%20and%20amber%20gradient%20flowing%20lines%20modern%20minimal%20design%20geometric%20patterns%20subtle%20glow%20effect%20smooth%20curves%20elegant%20atmosphere%20clean%20aesthetic%20warm%20color%20palette%20harmonious%20composition&width=1920&height=800&seq=cta-bg-51&orientation=landscape"
          alt="51在线入口"
          className="w-full h-full object-cover object-top"
        />
      </div>

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/35 to-black/50"></div>

      {/* Content */}
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4">
        <h2 className="text-3xl md:text-5xl font-heading font-black text-background-50 text-center tracking-wide uppercase">
          51 在线入口
        </h2>
        <p className="mt-4 text-sm md:text-base text-background-50/80 text-center max-w-lg leading-relaxed">
          最新51在线资源实时更新中
          <br />
          吃瓜群众不可错过的终极资源入口
        </p>

        <Link
          to="/category/51online"
          className="mt-8 group inline-flex items-center gap-0 bg-foreground-900 hover:bg-foreground-800 rounded-full transition-all duration-300 cursor-pointer"
        >
          <span className="w-11 h-11 rounded-full bg-accent-500 flex items-center justify-center flex-shrink-0">
            <i className="ri-rocket-line text-foreground-950 text-lg w-5 h-5 flex items-center justify-center"></i>
          </span>
          <span className="px-6 text-background-50 font-bold text-sm whitespace-nowrap uppercase tracking-wider">
            立即进入
          </span>
          <span className="pr-4 text-background-50/60 group-hover:text-accent-400 transition-colors">
            <i className="ri-arrow-right-up-line text-lg w-5 h-5 flex items-center justify-center"></i>
          </span>
        </Link>
      </div>
    </section>
  );
}